import { useSyncExternalStore } from 'react'
import { parseRefIdQuery, type RefIdQuery } from '../utils/refIdQuery'

const REF_ID_QUERY_EMPTY: RefIdQuery = { isPresent: false, value: '' }

let cachedSearch = ''
let cachedRefIdQuery: RefIdQuery = REF_ID_QUERY_EMPTY

function subscribe(onChange: () => void) {
    window.addEventListener('popstate', onChange)
    window.addEventListener('hashchange', onChange)
    return () => {
        window.removeEventListener('popstate', onChange)
        window.removeEventListener('hashchange', onChange)
    }
}

function getSnapshot(): RefIdQuery {
    const search = window.location.search
    if (search === cachedSearch) {
        return cachedRefIdQuery
    }
    cachedSearch = search
    const next = parseRefIdQuery(search)
    cachedRefIdQuery =
        !next.isPresent && next.value === ''
            ? REF_ID_QUERY_EMPTY
            : { isPresent: next.isPresent, value: next.value }
    return cachedRefIdQuery
}

function getServerSnapshot(): RefIdQuery {
    return REF_ID_QUERY_EMPTY
}

/** Reads `refID` from the current URL and re-renders on navigation. */
export function useRefIdQuery(): RefIdQuery {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
